export class AddPointCommand {
    _arbitraryLine;
    _newPointPos;
    _pointID;
    _arbitraryEditCallback;
    constructor(arbitraryLine, point, arbitraryEditCallback) {
        this._arbitraryLine = arbitraryLine;
        this._newPointPos = point;
        this._arbitraryEditCallback = arbitraryEditCallback;
    }
    async execute() {
        this._pointID = this._arbitraryLine.addControlPoint(this._newPointPos);
        this._arbitraryEditCallback && this._arbitraryEditCallback();
    }
    //TODO
    async undo() { }
}
//# sourceMappingURL=arbitrary-line-command.js.map